/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Fact_CommandsInputs */

const en_wc_fact_commands = /** @type {(inputs: Wc_Fact_CommandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`422`)
};

/**
* | output |
* | --- |
* | "422" |
*
* @param {Wc_Fact_CommandsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_fact_commands = /** @type {((inputs?: Wc_Fact_CommandsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Fact_CommandsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_fact_commands(inputs)
});
export { wc_fact_commands as "wc.fact.commands" }